@if (alertService.alerts.length) {
    <div class="alert-box">
        <div class="alert-message">{{alertService.alerts[alertService.alerts.length - 1].message}}</div>
        @if (alertService.alerts.length > 1 ) {
            <div class="alert-count">{{alertService.alerts.length}}</div>
        }
        <div class="alert-close" (click)="close()">&#10761;</div>
    </div>
}